import { useState, useEffect } from "react";
import useLang from "../../../hooks/useLang";
import useAnalysisData from "./useAnalysisData";
import getOptions from "../../../utils/getOptions";
import ReportWizardFooter from "../ReportWizardFooter";
import Loader from "../../../components/Loader";
import { probabilityThresholds } from "../../../config/probabilityTags";

const useStepOne = ({
  analysisId,
  setAnalysisId,
  navigateWizard,
  isNavigating,
}) => {
  const lang = useLang();
  const { analysisState, featuresStatus, featuresData } = useAnalysisData({
    analysisId,
    setAnalysisId,
  });

  const [selectedFeatures, setSelectedFeatures] = useState();

  const handleTagging = (item) => {
    if (item?.probability != null) {
      let tag;
      let tagProbability = 0;
      probabilityThresholds.forEach((probabilityItem) => {
        if (
          item?.probability > probabilityItem.threshold &&
          item?.probability > tagProbability
        ) {
          tag = probabilityItem.tag;
          tagProbability = probabilityItem.threshold;
        }
      });
      return tag;
    }
    return null;
  };

  const featureOptions = getOptions(featuresData, "name", null, handleTagging);
  const isLoading = (status) => status !== "fulfilled" && status !== "rejected";

  const wizardFooterButtons = [
    {
      id: "next",
      caption: lang("common.next"),
      onClick: () => {
        navigateWizard(1);
      },
      disabled:
        !selectedFeatures ||
        (selectedFeatures?.value && selectedFeatures?.value?.length === 0) ||
        isNavigating,
      important: true,
    },
  ];

  const stepOneArticles = isNavigating
    ? [<Loader small />]
    : [
        {
          items: {
            id: "features",
            loading: isLoading(featuresStatus),
            options: featureOptions,
            type: "list",
            formItem: true,
            label: null,
            grow: true,
            idAsValue: true,
            value: selectedFeatures?.value,
            onChange: (data) => {
              setSelectedFeatures(data);
            },
            disabled: analysisState === "FINISHED",
          },
        },
      ];
  if (analysisState !== "FINISHED") {
    stepOneArticles.push(<ReportWizardFooter buttons={wizardFooterButtons} />);
  }

  const getSelectedIds = (items = []) =>
    items?.filter((item) => item?.selected).map((item) => item.id);

  useEffect(() => {
    if (featuresStatus !== "fulfilled") return;
    const selectedFeatureIds = getSelectedIds(featuresData);
    setSelectedFeatures({
      id: "features",
      value: selectedFeatureIds,
    });
    // eslint-disable-next-line
  }, [featuresStatus]);

  return { stepOneArticles, selectedFeatures };
};

export default useStepOne;
